import React from 'react';

const StepIndicator = ({ steps, currentStep, className = '' }) => {
  return (
    <div className={`flex items-center justify-center space-x-2 mb-6 ${className}`}>
      {steps.map((step, index) => (
        <div key={step.id} className="flex items-center">
          {/* Step Dot/Number */}
          <div
            className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-medium transition-all duration-300 ${
              currentStep >= step.id
                ? 'bg-theme-border text-white'
                : 'bg-theme-blue/30 text-theme-text border border-theme-border/30'
            }`}
          >
            {currentStep > step.id ? (
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            ) : (
              <span>{step.id}</span>
            )}
          </div>
          
          {/* Connecting Line */}
          {index < steps.length - 1 && (
            <div
              className={`w-12 h-0.5 mx-1 transition-all duration-300 ${
                currentStep > step.id
                  ? 'bg-theme-border'
                  : 'bg-theme-border/30'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;
